export default __webpack_public_path__ + "media/mock/src/img/logo_visa-264046e9bb21c99a26192a299d7c5f76.png";